import { Home, Plus, Package, Crown, PlayCircle } from "lucide-react";

export type MainTab = "home" | "create" | "packs" | "plans" | "guide";

const FAB_SIZE = 60; // px - الدائرة العائمة (+)

export function BottomNav({
  active,
  onChange,
  tier,
}: {
  active: MainTab;
  onChange: (tab: MainTab) => void;
  tier?: string | null;
}) {
  const subscribed = tier === "pro" || tier === "vip";
  const right: { key: MainTab; label: string; icon: typeof Home }[] = [
    { key: "home", label: "الرئيسية", icon: Home },
    { key: "packs", label: "حزمي", icon: Package },
  ];
  const left: { key: MainTab; label: string; icon: typeof Home }[] = [
    { key: "plans", label: subscribed ? "اشتراكي" : "الباقات", icon: Crown },
    { key: "guide", label: "الشرح", icon: PlayCircle },
  ];

  const tab = ({ key, label, icon: Icon }: { key: MainTab; label: string; icon: typeof Home }) => {
    const isActive = active === key;
    return (
      <button key={key} type="button" onClick={() => onChange(key)} className="flex-1 flex flex-col items-center gap-1 py-1 min-w-0">
        <Icon size={23} strokeWidth={isActive ? 2.25 : 1.75} className={isActive ? "text-tg-text" : "text-tg-hint"} />
        <span className={`text-[11px] truncate ${isActive ? "text-tg-text font-medium" : "text-tg-hint"}`}>{label}</span>
        {isActive && <span className="w-1 h-1 rounded-full" style={{ background: "#3B82F6" }} />}
      </button>
    );
  };

  return (
    <div className="relative shrink-0">
      {/* خلفية الشريط مع قصّ دائري للزر العائم (بدون backdrop-blur عمداً) */}
      <div
        className="absolute inset-0 border-t border-white/10 bg-tg-bg"
        style={{
          maskImage: `radial-gradient(circle ${FAB_SIZE / 2 + 4}px at 50% 0%, transparent 98%, black 100%)`,
          WebkitMaskImage: `radial-gradient(circle ${FAB_SIZE / 2 + 4}px at 50% 0%, transparent 98%, black 100%)`,
        }}
      />

      <div className="relative flex items-center justify-around pt-2" style={{ paddingBottom: "max(0.5rem, env(safe-area-inset-bottom))" }}>
        {right.map(tab)}
        <div style={{ width: FAB_SIZE, flexShrink: 0 }} />
        {left.map(tab)}
      </div>

      <button
        type="button"
        onClick={() => onChange("create")}
        aria-label="إنشاء ملصق"
        className="absolute left-1/2 -translate-x-1/2 rounded-full flex items-center justify-center transition-transform active:scale-95"
        style={{
          width: FAB_SIZE,
          height: FAB_SIZE,
          top: -(FAB_SIZE * 0.42),
          background: "linear-gradient(135deg, #4C8DFF, #2F5BEA)",
          boxShadow: "0 6px 16px rgba(37, 99, 235, 0.45)",
        }}
      >
        <Plus size={26} strokeWidth={2.5} className="text-white" />
      </button>
    </div>
  );
}
